export const GET_CUSTOMERS = 'GET_CUSTOMER'
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMER_SUCCESS'
export const GET_CUSTOMERS_FAILED = 'GET_CUSTOMER_FAILED'
export const SEARCH_CUSTOMER = 'SEARCH_CUSTOMER'
export const SEARCH_CUSTOMER_SUCCESS = 'SEARCH_CUSTOMER_SUCCESS'
export const SEARCH_CUSTOMER_FAILED = 'SEARCH_CUSTOMER_FAILED'
export const GET_CONCEPTS = 'GET_CONCEPTS'
export const GET_CONCEPTS_SUCCESS = 'GET_CONCEPTS_SUCCESS'
export const GET_CONCEPTS_FAILED = 'GET_CONCEPTS_FAILED'

export const REIMPORT_CONCEPTS = 'REIMPORT_CONCEPTS'
export const REIMPORT_CONCEPTS_SUCCESS = 'REIMPORT_CONCEPTS_SUCCESS'
export const REIMPORT_CONCEPTS_FAILED = 'REIMPORT_CONCEPTS_FAILED'
export const GET_ECOMM_DATA = 'GET_ECOMM_DATA'
export const GET_ECOMM_DATA_SUCCESS = 'GET_ECOMM_DATA_SUCCESS'
export const GET_ECOMM_DATA_FAILED = 'GET_ECOMM_DATA_FAILED'

export const FETCH_CUSTOMER_EMAILS = 'FETCH_CUSTOMER_EMAILS'
export const FETCH_CUSTOMER_EMAILS_SUCCESS = 'FETCH_CUSTOMER_EMAILS_SUCCESS'
export const FETCH_CUSTOMER_EMAILS_FAILED = 'FETCH_CUSTOMER_EMAILS_FAILED'
export const REMOVE_CUSTOMER_EMAIL = 'REMOVE_CUSTOMER_EMAIL'
export const REMOVE_CUSTOMER_EMAIL_SUCCESS = 'REMOVE_CUSTOMER_EMAIL_SUCCESS'
export const REMOVE_CUSTOMER_EMAIL_FAILED = 'REMOVE_CUSTOMER_EMAIL_FAILED'
export const CONFIRM_CUSTOMER_EMAILS = 'CONFIRM_CUSTOMER_EMAILS'
export const CONFIRM_CUSTOMER_EMAILS_SUCCESS = 'CONFIRM_CUSTOMER_EMAILS_SUCCESS'
export const CONFIRM_CUSTOMER_EMAILS_FAILED = 'CONFIRM_CUSTOMER_EMAILS_FAILED'
export const ADD_CUSTOMER_EMAIL = 'ADD_CUSTOMER_EMAIL'
export const ADD_CUSTOMER_EMAIL_SUCCESS = 'ADD_CUSTOMER_EMAIL_SUCCESS'
export const ADD_CUSTOMER_EMAIL_FAILED = 'ADD_CUSTOMER_EMAIL_FAILED'

export const GET_CONCEPTS_PROFILE = 'GET_CONCEPTS_PROFILE'
export const GET_CONCEPTS_PROFILE_SUCCESS = 'GET_CONCEPTS_PROFILE_SUCCESS'
export const GET_CONCEPTS_PROFILE_FAILED = 'GET_CONCEPTS_PROFILE_FAILED'

export const GET_SALES_AGREEMENTS = 'GET_SALES_AGREEMENTS'
export const GET_SALES_AGREEMENTS_SUCCESS = 'GET_SALES_AGREEMENTS_SUCCESS'
export const GET_SALES_AGREEMENTS_FAILED = 'GET_SALES_AGREEMENTS_FAILED'

export const GET_CONTRACTS = 'GET_CONTRACTS'
export const GET_CONTRACTS_SUCCESS = 'GET_CONTRACTS_SUCCESS'
export const GET_CONTRACTS_FAILED = 'GET_CONTRACTS_FAILED'

export const RESENT_LINK = 'RESENT_LINK'
export const RESENT_LINK_SUCCESS = 'RESENT_LINK_SUCCESS'
export const RESENT_LINK_FAILED = 'RESENT_LINK_FAILED'

export const RESET_USER = 'RESET_USER'
export const RESET_USER_SUCCESS = 'RESET_USER_SUCCESS'
export const RESET_USER_FAILED = 'RESET_USER_FAILED'

export const CHECK_STATUS_FOR_RESENT_LINK = 'CHECK_STATUS_FOR_RESENT_LINK'
export const CHECK_STATUS_FOR_RESENT_LINK_SUCCESS = 'CHECK_STATUS_FOR_RESENT_LINK_SUCCESS'
export const CHECK_STATUS_FOR_RESENT_LINK_FAILED = 'CHECK_STATUS_FOR_RESENT_LINK_FAILED'

export interface SearchCustomerQueryObjectTypes {
  Query: string
  OuName: string
  AppId: string
  ModuleID: string
  ActivationStatus: string
  EcommerceStatus: string
  SalesRep: string
  SelectedCustomer: SelectedCustomerState | null
}

export interface SelectedCustomerState {
  custNo: string
  custName?: string
  custEosId: string
  shipToLocation?: string
  shipAddress?: string
  ouName?: string
  appId?: number
  salesRepEmail?: string
  ecomTabData?: unknown
  extractedConcept?: unknown
}

export type FiltrerAction =
  | { type: 'UPDATE_QUERY'; payload: string }
  | { type: 'UPDATE_MODULE_ID'; payload: string }
  | { type: 'UPDATE_ACTIVATION_STATUS'; payload: string }
  | { type: 'UPDATE_ECOMMERCE_STATUS'; payload: string }
  | { type: 'RESET_FILTERS' }
  | { type: 'UPDATE_APP_ID'; payload: string }
  | { type: 'UPDATE_OU_NAME'; payload: string }
  | { type: 'SET_SELECTED_CUSTOMER'; payload: SelectedCustomerState | null }
  | { type: 'CLEAR_SELECTED_CUSTOMER' }

export const GET_LOGS = 'GET_LOGS'
export const GET_LOGS_SUCCESS = 'GET_LOGS_SUCCESS'
export const GET_LOGS_FAILED = 'GET_LOGS_FAILED'

export const GET_ALL_WHOLESALER = 'GET_ALL_WHOLESALER'
export const GET_ALL_WHOLESALER_SUCCESS = 'GET_ALL_WHOLESALER_SUCCESS'
export const GET_ALL_WHOLESALER_FAILED = 'GET_ALL_WHOLESALER_FAILED'

export const GET_TEMPLATE_LIST = 'GET_TEMPLATE_LIST'
export const GET_TEMPLATE_LIST_SUCCESS = 'GET_TEMPLATE_LIST_SUCCESS'
export const GET_TEMPLATE_LIST_FAILED = 'GET_TEMPLATE_LIST_FAILED'

export const FETCH_FORM_DATA = 'FETCH_FORM_DATA'
export const FETCH_FORM_DATA_SUCCESS = 'FETCH_FORM_DATA_SUCCESS'
export const FETCH_FORM_DATA_FAILED = 'FETCH_FORM_DATA_FAILED'

export const DOWNLOAD_CSV_FILE = 'DOWNLOAD_CSV_FILE'
export const DOWNLOAD_CSV_FILE_SUCCESS = 'DOWNLOAD_CSV_FILE_SUCCESS'
export const DOWNLOAD_CSV_FILE_FAILED = 'DOWNLOAD_CSV_FILE_FAILED'

export const SET_SELECTED_CUSTOMER = 'SET_SELECTED_CUSTOMER'
export const CLEAR_SELECTED_CUSTOMER = 'CLEAR_SELECTED_CUSTOMER'
